import {
  calendarDateIcon, userIcon, calculatorIcon, printIcon, envelopeIcon, SVGIcon
} from "@progress/kendo-svg-icons";
import { Component, Input } from '@angular/core';
import { StepperComponent, StepperLabelTemplateDirective } from '@progress/kendo-angular-layout';
import { Step1Component } from 'src/app/pages/form/step1/step1.component';
import { Step2Component } from 'src/app/pages/form/step2/step2.component';
import { Step3Component } from 'src/app/pages/form/step3/step3.component';
import { Step4Component } from 'src/app/pages/form/step4/step4.component';
import { Step5Component } from 'src/app/pages/form/step5/step5.component';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { TranslatePipe } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { Router } from '@angular/router';
import { ROUTE_PATHS } from 'src/app/app.routes';
import { NgClass, NgOptimizedImage, NgStyle } from '@angular/common';
import { QuotationService } from 'src/app/shared/services/quotation.service';
import { RecaptchaModule, ReCaptchaV3Service } from 'ng-recaptcha-2';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [
    StepperComponent,
    StepperLabelTemplateDirective,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    TranslatePipe,
    ReactiveFormsModule,
    ButtonComponent,
    NgOptimizedImage,
    NgClass,
    NgStyle,
    RecaptchaModule
  ],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class FormComponent {
  @Input() public currentStep = 0;
  public isEmailValid: boolean;

  public steps: {label: string, disabled: boolean, current: boolean, svgIcon: SVGIcon}[] = [];
  public quotation: Quotation = new Quotation();
  public userExistsError = false;
  public missingNameError = false;
  public missingStartDateError = false;
  public missingEndDateError = false;
  public emailError = false;

  constructor(
    private router: Router,
    private quotationService: QuotationService,
    private recaptchaService: ReCaptchaV3Service) {
    this.steps = [
      {label: "STEP1.label", disabled: false, current: true, svgIcon: calendarDateIcon},
      {label: "STEP2.label", disabled: true, current: false, svgIcon: userIcon},
      {label: "STEP3.label", disabled: true, current: false, svgIcon: calculatorIcon},
      {label: "STEP4.label", disabled: true, current: false, svgIcon: printIcon},
      {label: "STEP5.label", disabled: true, current: false, svgIcon: envelopeIcon}
    ];
  }

  public nextStepHandler() {
    if (this.currentStep === 0) {
      if (this.quotation.name === '') {
        this.missingNameError = true;
      } else {
        this.missingNameError = false;
      }
      if (this.quotation.dates.start === null) {
        this.missingStartDateError = true;
      } else {
        this.missingStartDateError = false;
      }
      if (this.quotation.dates.end === null) {
        this.missingEndDateError = true;
      } else {
        this.missingEndDateError = false;
      }
      if (this.missingNameError || this.missingStartDateError || this.missingEndDateError) {
        return;
      }
    }
    this.missingNameError = false;
    this.missingStartDateError = false;
    this.missingEndDateError = false;
    this.currentStep += 1;
    this.steps[this.currentStep - 1].current = false;
    this.steps[this.currentStep].current = true;
    this.steps[this.currentStep].disabled = false;
    this.steps[this.currentStep].current = true;
  }

  public previousStepHandler() {
    this.currentStep -= 1;
    this.steps[this.currentStep + 1].current = false;
    this.steps[this.currentStep].current = true;
  }

  public emailHandler(isValid: boolean): void {
    this.isEmailValid = isValid;
  }

/*  public async preSubmit(callback: Function) {
    if (environment.production)
    this.recaptchaService.execute('submit').subscribe((token) => {
      // TODO: handle token
      this.quotationService.create(this.quotation).subscribe({
        next: () => {
          this.router.navigate([ROUTE_PATHS.SUCCESS]);
        },
        error: () => {
          this.router.navigate([ROUTE_PATHS.FAILURE]);
        }
      });
    });
  }*/

  public async submit() {
    if (this.quotation.email.length <= 0) {
      this.emailError = true;
      return;
    }
    this.quotationService.create(this.quotation).subscribe({
      next: () => this.router.navigate([ROUTE_PATHS.SUCCESS]),
      error: (error => {
        this.emailError = true;
        if (error.status === 602) {
          this.userExistsError = true;
        }
      })
    });
  }

}
